<template>
  <div class="index_background" style="padding: 20px">
    <el-form
      :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
      label-width="100px"
      class="demo-ruleForm"
      v-loading="loading"
      element-loading-text="拼命加载中"
      element-loading-spinner="el-icon-loading"
    >
      <h5 align="center">实名认证</h5>
      <el-form-item label="用户类型" prop="accountType">
        <el-select v-model="ruleForm.accountType" placeholder="请选择用户类型" readonly="true">
          <el-option label="企业" value="2"></el-option>
          <el-option label="个人" value="1"></el-option>
        </el-select>
        <!-- <el-input v-model="ruleForm.accountType" autocomplete="off" readonly="true"></el-input> -->
      </el-form-item>
      <el-form-item label="登录账号" prop="mobile">
        <el-input v-model="ruleForm.mobile"></el-input>
      </el-form-item>
      <el-form-item label="姓名" prop="name">
        <el-input v-model="ruleForm.name"></el-input>
      </el-form-item>
      <el-form-item label="身份证号" prop="identNo">
        <el-input v-model="ruleForm.identNo"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="authentic('ruleForm')">实名认证</el-button>
        <el-button type="info" @click="toLogin">去登录</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { getCompanyVerifyUrlApi } from '@/api/getData.js'
import { getPersonVerifyUrlApi } from '@/api/getData.js'
export default {
  components: {},
  data() {
    return {
      ruleForm: {
        name: '',
        identNo: '',
        mobile: ''
      },

      rules: {
        mobile: [
          { required: true, message: '请输入用户名', trigger: 'blur' },
          { min: 6, max: 11, message: '长度6-11个字符', trigger: 'blur' }
        ],
        name: [
          { required: true, message: '请输入姓名', trigger: 'blur' },
          { min: 1, max: 10, message: '长度在 1 到 10 个字符', trigger: 'blur' }
        ],
        accountType: [{ required: true, message: '请选择用户类型', trigger: 'change' }],
        identNo: [
          { required: true, message: '请输入身份证号码', trigger: 'blur' },
          { min: 1, max: 20, message: '长度在 18 到 20 个字符', trigger: 'blur' }
        ]
      },
      loading: false
    }
  },

  methods: {
    authentic(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          //实名认证
          this.toAuth()
        } else {
          this.$message({
            type: 'warning',
            message: '信息填写有误，请检查'
          })
        }
      })
    },
    toLogin() {
      this.$router.push({ name: 'login' })
    },
    toAuth() {
      var mobile = this.ruleForm.mobile
      var identNo = this.ruleForm.identNo
      var name = this.ruleForm.name
      var accountType = this.ruleForm.accountType
      if ('2' == accountType) {
        //调用认证接口获取认证url
        getCompanyVerifyUrlApi(mobile, 'identNo', 'name').then(res => {
          res = res.data
          if (res.code === 0) {
            let url = res.data.url //base64加密的url
            let Base64 = require('js-base64').Base64
            let decodeUrl = Base64.decode(url) //解密的url
            //跳转至fdd认证页面url
            window.location.href = decodeUrl
          } else {
            this.$message({
              type: 'warning',
              message: '认证失败！' + res.msg
            })
          }
        })
      }

      if ('1' == accountType) {
        //个人调用认证接口获取认证url
        getPersonVerifyUrlApi(mobile, name, identNo).then(res => {
          res = res.data
          if (res.code === 0) {
            let url = res.data.url //base64加密的url
            let Base64 = require('js-base64').Base64
            let decodeUrl = Base64.decode(url) //解密的url
            //跳转至fdd认证页面url
            window.location.href = decodeUrl
          } else {
            this.$message({
              type: 'warning',
              message: '认证失败！' + res.msg
            })
          }
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.el-form {
  // width: 420px;
  // margin: auto;
  // padding: 45px;
  // height: 550px;
  // background-color: #fff;
  // margin-left: 1000px;
  // margin-top: 50px;
  // border-radius: 15px;
  // background-image: url('../../assets/images/background.jpg');
  // background-repeat: no-repeat;
  // background-size: 100% 100%;
  // -moz-background-size: 100% 100%;

  position: absolute;
  width: 420px;
  height: 550px;
  padding: 45px;
  top: 10%;
  right: 5%;
  background-color: #fff;
  border-radius: 15px;
}
.el-button {
  padding: 10px 5px;
}
.el-form-item__label {
  text-align: right;
  vertical-align: middle;
  float: left;
  font-size: 14px;
  color: #606266;
  line-height: 50px;
  padding: 10px 12px 0 0;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}
.el-checkbox {
  padding-left: 0px;
}
.refreshCode {
  cursor: pointer;
}
h5 {
  font-size: max($numbers: 25px);
  padding-bottom: 50px;
}
.index_background {
  width: 100%;
  height: 100%;
  background-image: url('../../assets/images/background1.png');
  background-repeat: no-repeat;
  background-size: 100% 100%;
  -moz-background-size: 100% 100%;
}

element.style {
  margin-left: 30px;
}
.el-form-item__content {
  line-height: 40px;
  position: relative;
  font-size: 14px;
}
</style>
